import React from "react";

const InfoBox = ({ t, text }) => (
  <div className="info-box">
    <p>{t(text)}</p>
  </div>
);

export default InfoBox;
